import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetRequiredMilesRequest,
  failGetRequiredMiles,
  setGetRequiredMiles,
  setGetRequiredMilesFromApi,
  updateGetRequiredMiles,
  updateGetRequiredMilesFromApi,
} from './get-required-miles.actions';

/**
 * Service to handle async GetRequiredMiles actions
 */
@Injectable()
export class GetRequiredMilesEffect {
  /**
   * Set the state with the reply content, dispatch failGetRequiredMiles if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetRequiredMilesFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetRequiredMiles({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetRequiredMiles({ error, requestId: action.requestId })),
        cancelGetRequiredMilesRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetRequiredMiles if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetRequiredMilesFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetRequiredMiles({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetRequiredMiles({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
